import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import {
  clearPackageResultsAction, searchPackageAction, searchPackageFlightsForDesktopAction, setShowedPackageDetailsAction
} from '@packages/packages-result/store/actions/packages-result.actions';

export interface ShowedPackageDetailsFlightsState extends EntityState<string> { }

function getId(key: string): string {
  return key;
}

export const showedPackageDetailsAdapter: EntityAdapter<string> = createEntityAdapter<string>({
  selectId: getId
});

export const initialState: ShowedPackageDetailsFlightsState = showedPackageDetailsAdapter.getInitialState({});

const reducer = createReducer(
  initialState,
  on(searchPackageAction, () => initialState),
  on(searchPackageFlightsForDesktopAction, () => initialState),
  on(clearPackageResultsAction, () => initialState),
  on(setShowedPackageDetailsAction, (state, { payload }) => {
    const keys = state && state.entities ? Object.keys(state.entities) : [];
    if (!keys.includes(payload)) return showedPackageDetailsAdapter.addOne(payload, state);
    else return showedPackageDetailsAdapter.removeOne(payload, state);
  })
);

export function showedPackageDetailsReducer(
  state: ShowedPackageDetailsFlightsState,
  action: Action): ShowedPackageDetailsFlightsState {
  return reducer(state, action);
}

export const { selectIds, selectEntities, selectAll, selectTotal } = showedPackageDetailsAdapter.getSelectors();
